'use client';

import { PropsWithChildren } from 'react';

import { cn } from '@/slw/shared/lib/utils';

export interface FieldGroupProps extends PropsWithChildren {
  className?: string;
}

export function FieldGroup({ children, className }: Readonly<FieldGroupProps>) {
  return <div className={cn('flex flex-col gap-1', className)}>{children}</div>;
}
